import { buildMaterialsSummaryPdf, type MaterialsSummaryPdfInput } from './materialsSummaryPdf';
import { loadImageDataUrl } from './dailyLogPdf';

/** Build the material consumption summary PDF and share it (mobile) or download it (desktop). */
export async function shareMaterialsSummaryPdf(input: Omit<MaterialsSummaryPdfInput, 'logoDataUrl'>): Promise<'shared' | 'downloaded'> {
  const logoDataUrl = await loadImageDataUrl('/logo.png');
  const blob = await buildMaterialsSummaryPdf({ ...input, logoDataUrl });

  const fileName = `Materials-Summary_${input.from}_${input.to}.pdf`;
  const file = new File([blob], fileName, { type: 'application/pdf' });
  const nav = navigator as Navigator & { canShare?: (d: ShareData) => boolean };

  if (nav.canShare && nav.canShare({ files: [file] })) {
    await nav.share({ files: [file], title: 'Material Consumption Summary' });
    return 'shared';
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = fileName; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
  return 'downloaded';
}
